<template>
  <div class="col-lg-3 theiaStickySidebar">
    <div class="stickysidebar">
      <div class="filter-clear">
        <div
          class="clear-filter mb-4 pb-lg-2 d-flex align-items-center justify-content-between"
        >
          <h5><i class="feather-filter me-2"></i>Filters</h5>
          <a
            href="#"
            class="clear-text"
            @click.prevent="courseFetchStore.clearAllFilters()"
          >
            Clear
          </a>
        </div>

        <div class="accordion accordion-customicon1 accordions-items-seperate">
          <!-- filter buat group -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingcustomicon1One">
              <a
                href="#"
                class="accordion-button"
                data-bs-toggle="collapse"
                data-bs-target="#collapsecustomicon1One"
                aria-expanded="false"
                aria-controls="collapsecustomicon1One"
              >
                Group <i class="fa-solid fa-chevron-down"></i>
              </a>
            </h2>
            <div
              id="collapsecustomicon1One"
              class="accordion-collapse collapse show"
              aria-labelledby="headingcustomicon1One"
              data-bs-parent="#accordioncustomicon1Example"
              style=""
            >
              <div class="accordion-body">
                <div
                  v-for="(item, index) in courseFetchStore.groupList"
                  :key="index"
                >
                  <label class="custom_check">
                    <input
                      type="checkbox"
                      name="select_specialist"
                      :value="item.course_group_id ?? item.id"
                      :checked="isGroupChecked(item)"
                      @change="toggleFilterGroup(item)"
                    />
                    <span class="checkmark"></span> [{{ item.code }}]
                    {{ item.name }}
                  </label>
                </div>
                <a
                  href="javascript:void(0);"
                  class="see-more-btn"
                  v-if="courseFetchStore.groupList.length > 10"
                  >See More</a
                >
              </div>
            </div>
          </div>
          <!-- filter buat group -->

          <!-- filter buat instructor -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingcustomicon1Two">
              <a
                href="#"
                class="accordion-button"
                data-bs-toggle="collapse"
                data-bs-target="#collapsecustomicon1Two"
                aria-expanded="false"
                aria-controls="collapsecustomicon1Two"
              >
                Instructors<i class="fa-solid fa-chevron-down"></i>
              </a>
            </h2>
            <div
              id="collapsecustomicon1Two"
              class="accordion-collapse collapse show"
              aria-labelledby="headingcustomicon1Two"
              data-bs-parent="#accordioncustomicon1Example"
            >
              <div class="accordion-body">
                <div
                  v-for="(item, index) in userStore.ActiveTeachers"
                  :key="index"
                >
                  <label class="custom_check">
                    <input
                      type="checkbox"
                      name="select_specialist"
                      :value="item.userID"
                      :checked="
                        courseFetchStore.filterInstructor.includes(item.userID)
                      "
                      @change="toggleFilterInstructor(item.userID)"
                    />
                    <span class="checkmark"></span>
                    {{ authStore.userName(item.userID) }}
                  </label>
                </div>
                <a
                  href="javascript:void(0);"
                  class="see-more-btn"
                  v-if="userStore.ActiveTeachers > 10"
                  >See More</a
                >
              </div>
            </div>
          </div>
          <!-- filter buat instructor -->

          <!-- <div class="accordion-item">
                        <h2 class="accordion-header" id="headingcustomicon1Four">
                            <a href="#" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapsecustomicon1Four" aria-expanded="false" aria-controls="collapsecustomicon1Four">
                            Range<i class="fa-solid fa-chevron-down"></i>
                            </a>
                        </h2>
                        <div id="collapsecustomicon1Four" class="accordion-collapse collapse show" aria-labelledby="headingcustomicon1Four" data-bs-parent="#accordioncustomicon1Example">
                            <div class="accordion-body">
                                <div class="filter-range">
                                    <a-slider v-model:value="value" range />
                                </div>
                            </div>
                        </div>
                    </div> -->

          <!-- filter buat level -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingcustomicon1Five">
              <a
                href="#"
                class="accordion-button"
                data-bs-toggle="collapse"
                data-bs-target="#collapsecustomicon1Five"
                aria-expanded="false"
                aria-controls="collapsecustomicon1Five"
              >
                Level<i class="fa-solid fa-chevron-down"></i>
              </a>
            </h2>
            <div
              id="collapsecustomicon1Five"
              class="accordion-collapse collapse show"
              aria-labelledby="headingcustomicon1Five"
              data-bs-parent="#accordioncustomicon1Example"
            >
              <div class="accordion-body">
                <div
                  v-for="(item, index) in courseFetchStore.difficultyList"
                  :key="index"
                >
                  <label class="custom_check custom_one">
                    <input
                      type="checkbox"
                      name="select_specialist"
                      :value="item"
                      :checked="
                        courseFetchStore.filterDifficulties.includes(item)
                      "
                      @change="toggleFilterDifficulties(item)"
                    />
                    <span class="checkmark"></span>{{ item }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- filter buat level -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCourseFetchStore } from "@/stores/course/course-fetch-store";
import { useUserStore } from "@/stores/user/user-store";
import { computed, onMounted } from "vue";
import { useAuthStore } from "@/stores/auth-store";

/* const value = ref([10, 50]); */

export default {
  data() {
    return {};
  },
  setup() {
    const courseFetchStore = useCourseFetchStore();
    const userStore = useUserStore();
    const authStore = useAuthStore();

    onMounted(() => {
      // logika saat komponen pertama kali dirender
      courseFetchStore.fetchGroupList();
      courseFetchStore.fetchDifficultyList();
      userStore.fetchTeachers();
    });
    const limitedTeachers = computed(() =>
      userStore.ActiveTeachers.slice(0, 10)
    );
    return {
      courseFetchStore,
      userStore,
      limitedTeachers,
      authStore,
    };
  },
  methods: {
    toggleFilterDifficulties(difficulty) {
      const index =
        this.courseFetchStore.filterDifficulties.indexOf(difficulty);
      if (index === -1) {
        this.courseFetchStore.filterDifficulties.push(difficulty);
      } else {
        this.courseFetchStore.filterDifficulties.splice(index, 1);
      }
      this.courseFetchStore.pagination.currentPage = 1;
    },
    toggleFilterInstructor(instructor) {
      const index = this.courseFetchStore.filterInstructor.indexOf(instructor);
      if (index === -1) {
        this.courseFetchStore.filterInstructor.push(instructor);
      } else {
        this.courseFetchStore.filterInstructor.splice(index, 1);
      }
      this.courseFetchStore.pagination.currentPage = 1;
    },
    toggleFilterGroup(item) {
      const targetId = typeof item === "object" && item !== null
        ? (item.course_group_id ?? item.id)
        : item;
      const index = this.courseFetchStore.filterGroup.findIndex(
        (val) => String(val) === String(targetId)
      );
      if (index === -1) {
        this.courseFetchStore.filterGroup.push(targetId);
      } else {
        this.courseFetchStore.filterGroup.splice(index, 1);
      }
      this.courseFetchStore.pagination.currentPage = 1;
    },
    isGroupChecked(item) {
      const targetId = typeof item === "object" && item !== null
        ? (item.course_group_id ?? item.id)
        : item;
      return this.courseFetchStore.filterGroup.some(
        (val) => String(val) === String(targetId)
      );
    },
  },
};
</script>
